<!-- Body Content -->
<div
  class="pt-2 md:pt-3 md:px-4 px-2 pb-8"
  data-testid="form-templates-container"
>
  <div class="flex justify-content-between">
    <h1
      class="text-base md:text-lg flex align-items-center mb-0 line-height-1"
      data-testid="page-title"
    >
      {{ 'SURVEY_FORMS.PAGE_TITLE' | translate }}
      <a
        class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600"
        href="https://guides.unifiedfitnessplatform.ai"
        target="_blank"
        data-testid="help-guide-link"
      >
        <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
        <span class="ml-2 hidden md:inline-block">
          {{ 'SURVEY_FORMS.HELP_GUIDE' | translate }}
        </span>
        >
      </a>
    </h1>

    <div class="ml-2 flex align-items-center justify-content-end relative">
      <div
        (click)="createNewTemplate()"
        class="hidden md:inline-block"
        data-testid="create-template-link"
      >
        <p-button
          icon="fa fa-plus"
          [label]="'SURVEY_FORMS.CREATE_TEMPLATE' | translate"
          styleClass="surface-0 p-button-outlined text-sm"
          aria-label="create-template-button"
        />
      </div>
      <div
        (click)="createNewTemplate()"
        class="md:hidden"
        data-testid="create-template-link-mobile"
      >
        <p-button
          icon="fa fa-plus"
          styleClass="surface-0 p-button-outlined"
          aria-label="create-template-button-mobile"
        />
      </div>

      <p-button
        icon="fa fa-ellipsis-h"
        styleClass="surface-0 p-button-outlined border-300 ml-2 md:ml-3"
        pStyleClass="@next"
        enterFromClass="hidden"
        enterActiveClass="scalein"
        leaveToClass="hidden"
        leaveActiveClass="fadeout"
        [hideOnOutsideClick]="true"
        aria-label="more-options-button"
      />
      <!-- Dropdown -->
      <ul
        class="list-none ml-0 px-0 py-2 border-round shadow-2 absolute text-800 hidden origin-top w-10rem right-0 top-0 mt-6 z-2 surface-0 text-left text-sm z-2"
        data-testid="more-options-dropdown"
      >
        <li
          (click)="openFolderListDialog()"
          class="px-3 py-2 flex align-items-center hover:surface-100 cursor-pointer"
          data-testid="manage-folders-option"
        >
          {{ 'SURVEY_FORMS.MANAGE_FORM_FOLDERS' | translate }}
        </li>
      </ul>
      <!-- Dropdown -->
    </div>
  </div>

  <div class="mt-1" data-testid="breadcrumb-container">
    <app-breadcrumb />
  </div>

  <div
    class="surface-0 shadow-2 border-round my-3"
    data-testid="templates-table-container"
  >
    <div
      class="p-3 flex flex-wrap align-items-center justify-content-between border-bottom-1 border-300 gap-2"
    >
      <span class="text-900 font-normal text-sm mr-2" data-testid="total-count">
        {{ 'ADMIN.COMMON.TOTAL' | translate }} -
        <strong>{{ tableData().length }}</strong>
        {{ 'SURVEY_FORMS.TEMPLATES' | translate }}
      </span>

      <div class="flex flex-wrap align-items-center gap-2" data-testid="form-template-filters">
        <!-- Search -->
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="fa fa-search" />
          <input type="text" pInputText
            [placeholder]="'common.PLACEHOLDER.SEARCH' | translate"
            class="text-sm w-full md:w-14rem"
            [ngModel]="searchText()"
            (input)="onSearch($any($event.target).value)"
            aria-label="search-form-templates-input"
            data-testid="search-form-templates-input" />
        </p-iconfield>

        <!-- Folder Filter -->
        <p-select
          [options]="folderFilterOptions()"
          [ngModel]="selectedFolderId()"
          optionLabel="name"
          optionValue="value"
          class="text-sm w-full md:w-14rem"
          (onChange)="onFolderFilterChange($event.value)"
          aria-label="folder-filter-dropdown"
          data-testid="folder-filter-dropdown">
          <ng-template pTemplate="selectedItem" let-selected>
            <div class="text-sm">
              {{ selected?.name | translate }}
              <!-- @if (selected?.value === undefined) {
                {{ selected?.name | translate }}
              } @else {
                {{ selected?.name | translate }}
              } -->
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="text-sm">
              @if (item.value === undefined) {
                {{ item.name | translate }}
              } @else {
                {{ item.name | translate }}
              }
            </div>
          </ng-template>
        </p-select>

        <!-- Status Filter -->
        <p-select
          [options]="statusFilters"
          [(ngModel)]="selectedStatusFilter"
          optionLabel="name"
          optionValue="value"
          class="text-sm w-full md:w-11rem"
          (onChange)="onStatusFilterChange($event.value)"
          aria-label="status-filter-dropdown"
          data-testid="status-filter-dropdown">
          <ng-template pTemplate="selectedItem" let-selected>
            <div class="text-sm">{{ selected?.name | translate }}</div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="text-sm">{{ item.name | translate }}</div>
          </ng-template>
        </p-select>

        @if (showAuditLogsFeature()) {
          <div class="hidden md:inline-block">
            <p-button (click)="showAuditTrail()" [label]="'Show Logs'" icon="fa fa-history" styleClass="text-sm p-button-text white-space-nowrap" aria-label="show-logs-button" />
          </div>
          <div class="md:hidden">
            <p-button (click)="showAuditTrail()" icon="fa fa-history" styleClass="p-button-outlined" aria-label="show-logs-button-mobile" />
          </div>
        }
      </div>
    </div>
    <app-data-grid
      [hidden]="loading()"
      [columnData]="tableData$"
      [loading]="loading()"
      [columns]="columns$"
      [totalRecords]="totalRecordLength$"
      [paginator]="false"
      [EmptyState]="emptyStateComponent$"
      [selectable]="selectAllData$"
      [resizableColumns]="true"
      [columnResizeMode]="'expand'"
      (onAction)="onActionEvent($event)"
      data-testid="templates-grid"
      [gridName]="'form-template-list'"
    />
  </div>
</div>
<!-- Body Content -->

@if (showAuditTrailSidebar() && showAuditLogsFeature()) {
  <p-drawer
    [visible]="showAuditTrailSidebar()"
    position="right"
    [modal]="true"
    [appendTo]="'body'"
    [autoZIndex]="true"
    [blockScroll]="true"
    [showCloseIcon]="false"
    styleClass="w-full md:w-30rem"
    (onHide)="hideAuditTrail()"
    aria-label="audit-trail-sidebar"
    header="Activity Log"
    data-testid="audit-trail-sidebar">
    <ng-template pTemplate="content">
      <fitness-force-audit-trail-mini entityType="form_templates"
        entityId=""
        [tenantId]="tenantIdNumeric()"
        [tenantData]="[]"
        [maxEvents]="10"
        [showStats]="true"
        [showFilters]="true"
        [showPagination]="true"
        height="100vh"
        title="Form Template Activity Log"
        [showCloseButton]="true"
        (closeEvent)="hideAuditTrail()"
        data-testid="audit-trail-mini-component" />
    </ng-template>
  </p-drawer>
}

<!-- Folder Management Dialog -->
<lib-folder-management
  [visible]="showFolderDialog()"
  [tenantId]="tenantId()"
  [editFolder]="editingFolder()"
  [parentFolders]="folders()"
  (visibleChange)="showFolderDialog.set($event)"
  (folderSaved)="onFolderSaved()"
/>

<!-- Manage Form Folders Dialog -->
<p-dialog
  [visible]="showFolderListDialog()"
  [modal]="true"
  [style]="{ width: '600px' }"
  [header]="'SURVEY_FORMS.MANAGE_FORM_FOLDERS' | translate"
  (onHide)="showFolderListDialog.set(false)"
  [resizable]="false"
  data-testid="folder-list-dialog"
>
  <div class="flex flex-column gap-3">
    <div class="flex justify-content-between align-items-center">
      <p-button
        icon="fa fa-plus"
        [label]="'SURVEY_FORMS.CREATE_NEW_FOLDER' | translate"
        styleClass="p-button-sm"
        (click)="openCreateFolderFromManage()"
        data-testid="create-new-folder-button"
        aria-label="create-new-folder-button"
      />
      <p-button
        icon="fa fa-file-alt"
        [label]="'SURVEY_FORMS.CREATE_FORM' | translate"
        styleClass="p-button-outlined p-button-sm"
        (click)="createFormFromManage()"
        data-testid="create-form-button"
        aria-label="create-form-button"
      />
    </div>

    <div class="border-top-1 border-200 pt-3">
      @if (folders().length === 0) {
        <p class="text-center text-500">
          {{ 'SURVEY_FORMS.NO_FOLDERS_YET' | translate }}
        </p>
      }
      @for (folder of (folders() ?? []); track folder.id ?? $index) {
        <div
          class="flex align-items-center justify-content-between p-3 surface-50 border-round mb-2"
        >
          <span class="font-medium">{{ folder.name }}</span>
          <div class="flex gap-1">
            <p-button
              icon="fa fa-file-alt"
              styleClass="p-button-text p-button-sm"
              [pTooltip]="'SURVEY_FORMS.CREATE_FORM_IN_FOLDER' | translate"
              (click)="createFormInFolder(folder.id ?? undefined)"
              data-testid="create-form-in-folder"
              aria-label="create-form-in-folder"
            />
            <p-button
              icon="fa fa-edit"
              styleClass="p-button-text p-button-sm"
              (click)="
                editingFolder.set(folder);
                showFolderDialog.set(true)
              "
              aria-label="edit-folder"
            />
          </div>
        </div>
      }
    </div>
  </div>
</p-dialog>
